module.exports = __webpack_public_path__ + "img/tree-deciduous.d883a60d.svg";